module.exports = __webpack_public_path__ + "static/media/Vestas_Picture1.08587be2.png";